export enum DurationUnit
{
    Millisecond = "Millisecond",
    Second = "Second",
    Minute = "Minute",
    Hour = "Hour",
    Day = "Day",
    Week = "Week",
    Month = "Month",
    Year = "Year"
};

export class TimeUnitOperation
{
    static toMilliseconds(value: number, unit: DurationUnit): number
    {
        let milliseconds = 0;
        if (unit === DurationUnit.Millisecond)
            milliseconds = value;
        else if (unit === DurationUnit.Second)
            milliseconds = value * 1000;
        else if (unit === DurationUnit.Minute)
            milliseconds = value * 1000 * 60;
        else if (unit === DurationUnit.Hour)
            milliseconds = value * 1000 * 60 * 60;
        else if (unit === DurationUnit.Day)
            milliseconds = value * 1000 * 60 * 60 * 24;
        else if (unit === DurationUnit.Week)
            milliseconds = value * 1000 * 60 * 60 * 24 * 7;
        else if (unit === DurationUnit.Month)
            milliseconds = value * 1000 * 60 * 60 * 24 * 30;
        else if (unit === DurationUnit.Year)
            milliseconds = value * 1000 * 60 * 60 * 24 * 365;
        return milliseconds;
    }
    static toSeconds(value: number, unit: DurationUnit): number
    {
        return Math.round(TimeUnitOperation.toMilliseconds(value, unit) / 1000);
    }
}